import { render } from "./CurriculumSetup.vue?vue&type=template&id=586e0886&scoped=true"
import script from "./CurriculumSetup.vue?vue&type=script&lang=js"
export * from "./CurriculumSetup.vue?vue&type=script&lang=js"

import "./CurriculumSetup.vue?vue&type=style&index=0&id=586e0886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586e0886"]])

export default __exports__